<div class="modal-content">
  <div class="modal-header bg-tertiary">
    <h6 class="modal-title fw-bold" id="addConfigurationModalLabel">Translation Import</h6>
    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
  </div>

  <div class="modal-body">
    <div class="row">
      <div class="col">
        <label class="form-label">JSON data to import</label>
        <textarea [(ngModel)]="dataToImport" placeholder="array or object" class="form-control"></textarea>
      </div>
    </div>

    <div class="row mt-4">
      <div class="col">
        <label class="form-label">Key expression</label>
        <div class="input-group">
          <span class="input-group-text"><i class="bi bi-person-check"></i></span>
          <input [(ngModel)]="keyExpression" placeholder="Ex: message%i%, zodiac.%i%.desc, etc." class="form-control"/>
        </div>
      </div>
    </div>
  </div>

  <div class="modal-footer bg-tertiary">
    <button type="button" class="btn btn-outline-primary fw-bold" data-bs-dismiss="modal">Close</button>
    <button (click)="import()" type="button" class="btn btn-primary fw-bold">Import</button>
  </div>
</div>
